$(document).ready( function(){

	if($('.image-gallery').length > 0){

		var image_gallery = $('.image-gallery');
		var popup_trigger = image_gallery.find('.trigger');
		var image_gallery_popup = $('.image-gallery-popup');
		var image_gallery_popup_slides = image_gallery_popup.find('.slide');
		var image_gallery_popup_close = image_gallery_popup.find('.close');

		var slider = $('.slider');
		var slider_nav_trigger = slider.find('.trigger');

		popup_trigger.click( function(){
	    	image_gallery_popup.addClass('active');
	    	image_gallery_popup_slides.removeClass('current');
	    	image_gallery_popup_slides.removeClass('next');
	    	var current_slide = image_gallery_popup.find('#' + $(this).data('slide'));
	    	if(current_slide.next('.slide').length){
	    		var next_slide = current_slide.next('.slide');
	    	}else{
	    		var next_slide = image_gallery_popup.find('.slide').first();
	    	}
	    	current_slide.addClass('current');
	    	next_slide.addClass('next');

	    	// update nav
	    	slider_nav_trigger.removeClass('current');
	    	$('.slider .trigger[data-slide="' + current_slide.attr('id') + '"]').addClass('current'); 
	    });

	    image_gallery_popup_close.click( function(){
	    	image_gallery_popup.removeClass('active');
	    });

	}
});